import React, { useState } from 'react';
import { SignupData } from '../../pages/SignupPage';
import PlayerForm from './profileForms/PlayerForm';
import CoachForm from './profileForms/CoachForm';
import ManagerForm from './profileForms/ManagerForm';
import AgentForm from './profileForms/AgentForm';
import ScoutForm from './profileForms/ScoutForm';
import RefereeForm from './profileForms/RefereeForm';
import JournalistForm from './profileForms/JournalistForm';
import FanForm from './profileForms/FanForm';
interface ProfileDetailsFormProps {
  onSubmit: () => void;
  onBack: () => void;
  updateData: (data: Partial<SignupData>) => void;
  data: SignupData;
}
const ProfileDetailsForm: React.FC<ProfileDetailsFormProps> = ({
  onSubmit,
  onBack,
  updateData,
  data
}) => {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const updateProfileDetails = (details: any) => {
    updateData({
      profileDetails: {
        ...data.profileDetails,
        ...details
      }
    });
  };
  const renderProfileForm = () => {
    switch (data.profileType) {
      case 'player':
        return <PlayerForm updateDetails={updateProfileDetails} data={data} data-id="element-20" />;
      case 'coach':
        return <CoachForm updateDetails={updateProfileDetails} data={data} data-id="element-21" />;
      case 'manager':
        return <ManagerForm updateDetails={updateProfileDetails} data={data} data-id="element-22" />;
      case 'agent':
        return <AgentForm updateDetails={updateProfileDetails} data={data} data-id="element-23" />;
      case 'scout':
        return <ScoutForm updateDetails={updateProfileDetails} data={data} data-id="element-24" />;
      case 'referee':
        return <RefereeForm updateDetails={updateProfileDetails} data={data} data-id="element-25" />;
      case 'journalist':
        return <JournalistForm updateDetails={updateProfileDetails} data={data} data-id="element-26" />;
      case 'fan':
        return <FanForm updateDetails={updateProfileDetails} data={data} data-id="element-27" />;
      default:
        return <PlayerForm updateDetails={updateProfileDetails} data={data} data-id="element-28" />;
    }
  };
  const validate = () => {
    // Basic validation can be added here
    return true;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
      onSubmit();
    }
  };
  return <div className="p-4" data-id="element-29">
      <h2 className="text-xl font-bold text-center mb-2" data-id="element-30">
        Complete Your{' '}
        {data.profileType.charAt(0).toUpperCase() + data.profileType.slice(1)}{' '}
        Profile
      </h2>
      <p className="text-gray-600 text-center mb-6" data-id="element-31">
        Add details to your profile to help others find and connect with you
      </p>
      <form onSubmit={handleSubmit} data-id="element-32">
        {renderProfileForm()}
        <div className="mt-6" data-id="element-33">
          <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg text-sm px-5 py-3 text-center" data-id="element-34">
            Complete Sign Up
          </button>
        </div>
      </form>
    </div>;
};
export default ProfileDetailsForm;